import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class ResetPssService {
  constructor(private http: HttpClient) {}
  postLogin(formData: any,token): Observable<any> {
    // const data = JSON.stringify(formData.value);
    const data = {
      password: formData.password,
      token:token
    };
 
    return this.http.post(environment.serverUrl + 'reset_password', data);

  }
}

